import { render, staticRenderFns } from "./trainingModule.vue?vue&type=template&id=db43746c"
import script from "./trainingModule.vue?vue&type=script&lang=js"
export * from "./trainingModule.vue?vue&type=script&lang=js"
import style0 from "./trainingModule.vue?vue&type=style&index=0&id=db43746c&prod&lang=css"
import style1 from "./trainingModule.vue?vue&type=style&index=1&id=db43746c&prod&slot-scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports